import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
    state() {
        return {
            mode: 'asset',
            productTypes: [],
            commonChoices: [],
            selfManaged: [],
            selfManagedDetails: {},
            finalPayload: {},
            selectedNewSelfManagedType: null,
            selectedProduct: [],
            split: null,
            holdings: [],
            editing: null,
            fundlinks: [],
            fundlinksLoading: false,
            isEditingExistingValuationHolding: false,
            isEditingExistingValuationHoldingIndex: null,
            // liability versions
            liabilityTypes: [],
            selfManagedLiabilities: [],
            selfManagedLiabilityDetails: {},
            openID: false,
            removeID: false,
            valuationHistory: [],
            valuationHistoryLoading: false,
        };
    },
    actions,
    getters,
    mutations,
};
